import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BodyCopy } from "../../../components/BodyCopy";
import {
  AuraLayout,
  Button,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { ErrorAlertIcon as ErrorIcon } from "../../../assets/icons";
import { FlowHeroMark } from "../../../components/FlowHeroMark";
import { M2M_ROUTES } from "../../../constants";
import { useStore } from "../../../store/globalState";
import { ScrollFadeIndicator } from "../../../components/ScrollFadeIndicator";

/**
 * Shared service-unavailable fallback reused by every flow. In production the
 * CTA redirects to the partner `callbackUrl`; in the gallery it navigates back
 * to the generic landing screen so the user stays inside the screenbook.
 */
export const ServiceUnavailablePage = memo(() => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const navigate = useNavigate();

  const colorConfig = theme.errorView;
  const { backgroundBtn, textColorBtn, title, bodyCopy, iconColors, backgroundIcon } =
    colorConfig;

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />

        <section className="flow-hero">

          <FlowHeroMark backgroundIcon={backgroundIcon}>

            <ErrorIcon size={60} colors={iconColors} />

          </FlowHeroMark>
        <section className="landing-container">
          <PageTitle
            highlight={t("error.serviceUnavailableTitle")}
            highlightColor={title}
            secudnary=""
            secudnaryColor={title}
          />
          <BodyCopy textColor={bodyCopy}>
            {t("error.serviceUnavailableMessage")}
          </BodyCopy>
        </section>
        </section>
      </Layout.Content>
      <Layout.Footer>
        <section className="footer-section">
          <Button
            size="large"
            background={backgroundBtn}
            color={textColorBtn}
            onClick={() => navigate(M2M_ROUTES.LANDING)}
          >
            {t("error.goToApp")}
          </Button>
        </section>
      </Layout.Footer>
    </AuraLayout>
  );
});
